const labelsNL = {
    "view": {
        "table": {
            "title": "Uw labels lijst",
            "column": {
                "name": "Naam",
                "owner": "Eigenaar",
                "company": "Bedrijf",
                "contract": "Contract",
                "info": "Info",
                "status": "Status",
                "action": "Actie"
            },
            "button": {
                "edit": "Bewerken",
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "label": {
                "approved": "Goedgekeurd",
                "waiting_approval": "Wacht op goedkeuring"
            }
        },
        "message": {
            "success": "Label is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "notSubscribed": "Você não está inscrito em nenhum plano, portanto só pode adicionar <strong>3 rótulos</strong>. Por favor, <3>assine</3> um plano para ter quantidade ilimitada de rótulos.",
            "subscriptionUpgrade": "Uw huidige abonnementsplan ondersteunt deze functie niet. Gelieve <1>upgraden</1> uw abonnementsplan om deze functie te verkrijgen.",
            "subscriptionExpired": "Uw abonnement is verlopen. Gelieve <1>hervatten</1> uw abonnement om deze functie te verkrijgen.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        },
        "modal": {
            "delete": {
                "header": "Label {{labelName}} verwijderen?",
                "body": "Weet u zeker dat u label {{labelName}} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt."
            }
        }
    },
    "add": {
        "title": "Label toevoegen",
        "form": {
            "label": {
                "required": "Vereist",
                "name": "Naam",
                "subuser": "Sub-gebruiker",
                "logo": "Logo",
                "promo_graphic": "Promotionele Grafiek",
                "primary_genre": "Primaire genre",
                "secondary_genre": "Secundaire genre",
                "year_established": "Jaar van oprichting",
                "releases_in_catalog": "Uitgaven in catalogus",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Opmerking: Gebruik deze dropdown alleen als u een Label wilt toevoegen voor een van uw Sub-gebruikers, anders laat u deze niet geselecteerd.",
                "logo": "Upload JPG- of PNG-formaten, resolutie alleen 1000x1000 px",
                "promo_graphic": "Upload JPG- of PNG-formaten, resolutie alleen 960x150px, max 100kb"
            },
            "placeholder": {
                "subuser": "Selecteer Sub-gebruiker..."
            },
            "button": {
                "reset": "Resetten",
                "submit": "Indienen"
            },
            "message": {
                "success": "Label is toegevoegd!",
                "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Label {{labelName}} toevoegen?",
                "body": "Weet u zeker dat u een nieuw label wilt aanmaken? Zorg ervoor dat u een unieke labelnaam invoert. Om zeker te zijn, controleer of de naam al bestaat in winkels zoals Beatport en Traxsource. Elke inzending moet worden goedgekeurd en geregistreerd door het Music Link-team. We keuren en registreren nieuwe labels meestal binnen 48 uur.",
                "button": {
                    "confirm": "Bevestigen",
                    "cancel": "Annuleren"
                }
            }
        },
        "message": {
            "success": "Label is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    },
    "update": {
        "title": "Label bewerken",
        "form": {
            "label": {
                "required": "Vereist",
                "name": "Naam",
                "logo": "Logo",
                "promo_graphic": "Promotionele Grafiek",
                "primary_genre": "Primaire genre",
                "secondary_genre": "Secundaire genre",
                "year_established": "Jaar van oprichting",
                "releases_in_catalog": "Uitgaven in catalogus",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Upload JPG- of PNG-formaten, resolutie alleen 1000x1000 px",
                "promo_graphic": "Upload JPG- of PNG-formaten, resolutie alleen 960x150px, max 100kb"
            },
            "placeholder": {},
            "button": {
                "submit": "Indienen"
            },
            "message": {
                "success": "Label is bijgewerkt!",
                "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
            }
        }
    }
};

export default labelsNL;